// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__17h-1","title":"AfterFrontImage_title__3YKbv"};